(function () {
    'use strict';

    angular.module("imApp").factory("deviationTypesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1227,
                    parameters: parms || {}
                });
            },
            listDeviationTypes: function (parms) {
                return $ihttp.post({
                    method: 43,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
